import axios from 'axios'

export const getLanguages = async (filters) => {
  const res = (await axios.get(`/languages`, { params: filters })).data
  return res;
}

export const getLocalizations = async (query) => {
  const res = (await axios.get(`/localizations`, { params: query })).data
  return res;
}

export const getLocalizationsLastUpdate = async () => {
  const res = (await axios.get(`/localizations-last-upload`)).data
  return res;
}
